import React from "react";
import './Main.css';
import Content1 from "./Content1";
import Novosti from "./Novosti";
import Mapa from "./Mapa";
import Content2 from './Content2'

const Main = () => {

    return(
        <React.Fragment>
        <div className="contents">
            <Content1 />
        </div>
            <hr className="new1" />
            <Mapa className="mapa" />
            <Novosti />
            <Content2 />
        </React.Fragment>
    );

}

export default Main;